// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { NgModule, ErrorHandler } from "@angular/core";
import { RouterModule } from "@angular/router";
import { HttpClientModule } from '@angular/common/http';

import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { ToastaModule } from 'ngx-toasta';
import { ChartsModule } from 'ng2-charts';
import { NguCarouselModule } from '@ngu/carousel';

import { AppRoutingModule } from './app-routing.module';
import { AppErrorHandler } from './app-error.handler';

import { SharedModule } from './shared/shared.module'
import { AdminModule } from './admin/admin.module';
import { SettingsModule } from './settings/settings.module';
import { FooterModule } from './shared/footer.component';
import { ThemePickerModule } from './shared/theme-picker.component';

import { AppTitleService } from './services/app-title.service';
import { AppTranslationService, TranslateLanguageLoader } from './services/app-translation.service';
import { ConfigurationService } from './services/configuration.service';
import { AlertService } from './services/alert.service';
import { LocalStoreManager } from './services/local-store-manager.service';
import { EndpointFactory } from './services/endpoint-factory.service';
import { NotificationService } from './services/notification.service';
import { NotificationEndpoint } from './services/notification-endpoint.service';
import { AccountService } from './services/account.service';
import { AccountEndpoint } from './services/account-endpoint.service';

import { AppComponent } from "./app.component";
import { LoginComponent } from "./components/login/login.component";
import { LoginControlComponent } from "./components/login/login-control.component";
import { LoginDialogComponent } from "./components/login/login-dialog.component";
import { HomeComponent } from "./components/home/home.component";
import { AboutComponent } from "./components/about/about.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { BannerDemoComponent } from "./components/controls/banner-demo.component";
import { TodoDemoComponent } from "./components/controls/todo-demo.component";
import { StatisticsDemoComponent } from "./components/controls/statistics-demo.component";
import { NotificationsViewerComponent } from "./components/controls/notifications-viewer.component";
import { AddTaskDialogComponent } from './components/controls/add-task-dialog.component';
import { ReprezentariComponent } from "./components/reprezentari/reprezentari.component";
import { ReprezentantiComponent } from "./components/reprezentanti/reprezentanti.component";
import { ContulMeuComponent } from "./components/contulmeu/contulmeu.component";
import { PozeComponent } from "./components/poze/poze.component";
import { CompanieComponent } from "./components/companie/companie.component";
import { CompanieReprezentariComponent } from "./components/companieReprezentari/companieReprezentari.component";
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { UserRegisterComponent } from '../app/admin/user-register.component';
import { UserPasswordComponent } from '../app/admin/user-password.component';
import { SelecteazaCompanieComponent } from "./components/controls/selecteazaCompanie.component";
import { AngularFileUploaderModule } from "angular-file-uploader";
import { CarComponent } from "./components/car/car.component";
import { ConfiguratorComponent } from "./components/configurator/configurator.component";
import { ProductComponent } from "./components/product/product.component";
import { OfferComponent } from "./components/offer/offer.component";
import { DatePipe } from '@angular/common';
import { CatalogLinkComponent } from "./components/catalogLink/catalogLink.component";
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { AuditLoginComponent } from "./components/auditLogin/auditLogin.component";
import { EditDialogComponent } from "./components/editDialogComponent/editDialogComponent.component";

@NgModule({
  imports: [
    SharedModule,
    FooterModule,
    ThemePickerModule,
    HttpClientModule,
    AdminModule,
    SettingsModule,
    AppRoutingModule,
    AngularFileUploaderModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateLanguageLoader
      }
    }),
    ToastaModule.forRoot(),
    ChartsModule,
    NguCarouselModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule
  ],
  declarations: [
    AppComponent,
    LoginComponent, LoginControlComponent, LoginDialogComponent,
    HomeComponent,
    AboutComponent,
    NotFoundComponent,
    NotificationsViewerComponent,
    AddTaskDialogComponent,
    StatisticsDemoComponent,
    TodoDemoComponent,
    BannerDemoComponent,
    ReprezentariComponent,
    ContulMeuComponent,
    PozeComponent,
    ReprezentantiComponent,
    CompanieComponent,
    CompanieReprezentariComponent,
    UserRegisterComponent,
    UserPasswordComponent,
    SelecteazaCompanieComponent,
    CarComponent,
    ConfiguratorComponent,
    ProductComponent,
    OfferComponent,
    CatalogLinkComponent,
    AuditLoginComponent,
    EditDialogComponent
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: 'BASE_URL', useFactory: getBaseUrl },
    { provide: ErrorHandler, useClass: AppErrorHandler },
    AlertService,
    ConfigurationService,
    AppTitleService,
    AppTranslationService,
    NotificationService,
    NotificationEndpoint,
    AccountService,
    AccountEndpoint,
    LocalStoreManager,
    EndpointFactory,
    DatePipe
  ],
  entryComponents: [
    LoginDialogComponent,
    AddTaskDialogComponent,
    EditDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}



export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}
